import * as React from "react";
const SvgFiRrTentArrowTurnLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tent-arrow-turn-left_svg__a)">
      <path
        fill="#062147"
        d="M24 10v3a1 1 0 1 1-2 0v-3c0-2.206-1.794-4-4-4H2.579l2.153 2.317a1 1 0 1 1-1.465 1.362L.842 7.067c-1.13-1.128-1.13-3.006.025-4.16l2.4-2.585a1 1 0 1 1 1.465 1.361L2.582 4H18A6.005 6.005 0 0 1 24 10m-2.4 7.936a4.25 4.25 0 0 1-.27 4.09A4.26 4.26 0 0 1 17.726 24H6.278a4.25 4.25 0 0 1-3.603-1.975 4.24 4.24 0 0 1-.271-4.09c.022-.048 5.847-8.668 5.873-8.698C9.48 7.846 10.33 7 12 7c1.435 0 2.67.755 3.78 2.31 0 0 5.798 8.578 5.82 8.625M14.478 22l-1.974-3.644c-.154-.327-.401-.356-.501-.356s-.348.029-.474.302L9.527 22zm5.339-3.154-5.677-8.395C13.22 9.167 12.513 9 11.999 9c-.692 0-1.025.178-2.173 1.5l-5.64 8.345a2.22 2.22 0 0 0 .174 2.104 2.24 2.24 0 0 0 1.917 1.05h.974l2.489-4.597c.39-.845 1.268-1.403 2.26-1.403s1.869.559 2.288 1.458l2.462 4.542h.974c.793 0 1.49-.383 1.917-1.05a2.22 2.22 0 0 0 .174-2.104"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tent-arrow-turn-left_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTentArrowTurnLeft;
